import cc from "classcat";
import { TextInput, type SingleLineTextInputProps } from "@narmi/design_system";

import { useAmountEntryInput, type Path } from "../../adapters";

import styles from "./AmountEntryInput.module.scss";

import type { GenericForm } from "byzantine";

type AmountEntryInputProps<Form extends GenericForm<any>> = Omit<
  SingleLineTextInputProps,
  | "value"
  | "defaultValue"
  | "onChange"
  | "onBlur"
  | "error"
  | "id"
  | "placeholder"
  | "startContent"
  | "multiline"
  | "form"
> & {
  form: Form;
  field: Path<Form["values"]>;
};

/**
 * Text field for a cents amount in a form, typed left to right with a "$"
 * prefix and a "0.00" placeholder. See `useAmountEntryInput` for behavior.
 */
const AmountEntryInput = <Form extends GenericForm<any>>({
  form,
  field,
  className,
  ...textInputProps
}: AmountEntryInputProps<Form>) => {
  const amountProps = useAmountEntryInput(form, field);
  return (
    <TextInput
      {...textInputProps}
      {...amountProps}
      className={cc([styles.amountEntry, className])}
      placeholder="0.00"
      startContent={<span className={styles.prefix}>$</span>}
    />
  );
};

export default AmountEntryInput;
